











import { Component, Prop, Vue } from 'vue-property-decorator';
import PopField from '../PopField/index.vue';
import { fontSizeOptions, fontSizeSmallOptions } from '@/views/wheelOfFortune/constant/options';

/** 字号字段。tier=small 为隐私组专用小字档（10-16px），其余用 normal（12-100px）。 */
@Component({ components: { PopField } })
export default class FontSizeField extends Vue {
  @Prop({ type: String, default: '' }) value!: string;
  @Prop({ type: String, required: true }) label!: string;
  @Prop({ type: String, default: '' }) col!: string;
  @Prop({ type: String, default: 'normal' }) tier!: 'normal' | 'small';
  get options() { return this.tier === 'small' ? fontSizeSmallOptions : fontSizeOptions; }
}
